import { useResetAtom } from 'jotai/utils'
import React from 'react'

import { dialogInfoAtom } from '../atoms'

import { useInvalidateMainQuery } from './useInvalidateMainQuery'

export const useCloseDialogWithRefresh = () => {
  const resetDialogInfo = useResetAtom(dialogInfoAtom)
  const invalidateMainQuery = useInvalidateMainQuery()

  return React.useCallback(() => {
    invalidateMainQuery()
    resetDialogInfo()
  }, [invalidateMainQuery, resetDialogInfo])
}
